import { IssueOrderPeriod } from '@ipreo/muni-shared';
import { Tranche } from '../../gameday/data/gameDay-data.transformations';
import { GameDayModel } from '../../models/gameday-model';

/**
 * Order period mapper first defines if issue level order period is terminated
 * and then if each maturity in tranche has terminated order period.
 * It means that both issue and tranche maturities level order period are terminated.
 *
 * @param  issue
 * @param  tranche
 * @returns boolean
 */
export function orderPeriodMapper(
  deal: GameDayModel.Deal,
  tranche: Tranche
): boolean {
  const { isOpen } = IssueOrderPeriod.orderPeriodIsOpen(deal);

  return (
    isOpen &&
    tranche &&
    tranche.maturities &&
    tranche.maturities.length &&
    tranche.maturities.every(maturity => maturity.isOrderPeriodTerminated)
  );
}
